<style>
.edi-detail-bill .detail-bill-footer div.detail-bill-info p.total-p {
    margin: .5em 5px;
    font-size: 1em;
}
.edi-detail-bill .detail-scroll .bill-all-info-background{
	width: 100%;
}
.edi-detail-bill .detail-scroll .detail-bill-info-list-background {
	float: none;
}
.edi-detail-bill .detail-bill-list .detail-bill-fulllist {
	width: 100%;
	white-space: normal;
	word-break: break-all;
}
.edi-detail-bill .detail-bill-list .detail-bill-fulllist .detail-bill-list-title-right {
	color: #D25B47;
	float: right;
	text-align: right;
}
.edi-detail-bill .detail-bill-list .detail-bill-list-title-line{
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
</style>
<template>
	<div class="edi-detail-bill">
		<!-- <div class="filter">
			<input type="text" placeholder="" class="ui-search-input"/>
		</div> -->
		<navbar title="餐企报价单-明细"></navbar>
		<div v-show="scrollShow" class="common-scroll detail-scroll">
			<p class="detail-bill-status">订单号：{{billDetailData.trans_bill_no}}
				<span class="nav-btn" @click="openBillInfo()">
					<img src="../assets/nav-btn.png" alt="">
				</span>
				<span v-if="billDetailData.bill_state == 30" class="state-grey-font">未确认</span>
				<span v-if="billDetailData.bill_state == 31" class="state-aqua-font">已同意</span>
				<span v-if="billDetailData.bill_state == 32" class="state-red-font">已确认</span>
				<span v-if="billDetailData.bill_state == 35 && isZ5" class="state-red-font">已定价</span>
				<span v-if="billDetailData.bill_state == 39" class="state-grey-font">已退回</span>
			</p>
			<div class="bill-all-info bill-all-info-background" v-show="billInfoShow">
				<ul class="detail-bill-info-list detail-bill-info-list-background">
					<li class="detail-bill-fulllist">报价企业：{{billDetailData.restaurant_name}}</li>
					<li v-if="billDetailData.in_date && billDetailData.in_date.length" class="detail-bill-fulllist detail-bill-remark">
						报价截止时间：{{formatDate(billDetailData.in_date)}}
					</li>
				</ul>
			</div>
			<div class="detail-bill-search-wrapper">
				<input class="detail-search-input" placeholder="请输入要搜索的品项名称" v-model="searchWord">
			</div>
			<div class="detail-bill-wrapper">
				<h4 class="detail-bill-address aqua-font">
					明细条目({{detailsFilter.length}})
					<router-link v-if="billDetailData.bill_state == 31" :to="{ path: '/detail-quotation-edit', query: { bill_id: queryData.bill_id , searchWord: searchWord}}" class="detail-bill-edit state-aqua-font" replace>编辑</router-link>
				</h4>
				<ul class="detail-bill-list width-full">
					<li v-for="billDetail in detailsFilter" :key="billDetail.goods_id" class="width-full">
						<ul class="detail-bill-sonlist width-full">
							<li class="detail-bill-fulllist detail-bill-list-title detail-bill-list-title-line">
								<div>{{billDetail.goods_name}}({{billDetail.goods_unit}})</div>
								<div v-show="isZ5 && billDetailData.bill_state == 35" class="detail-bill-list-title-right">
									{{billDetail.pricing_state == 1 ? '中标' : '未中标'}}
								</div>
							</li>
							<li v-if="isPesc">规格：{{billDetail.goods_spec}}</li>
							<li>税率：{{billDetail.goods_cess}} %</li>
							<li>含税单价：{{billDetail.goods_price_send | numFixed(numScale)}} 元</li>
							<li v-show="billDetail.goods_price_recipient >= 0">上次价格档案单价：
								<span>{{billDetail.goods_price_recipient | numFixed(numScale)}} 元</span>
							</li>
							<li v-show="isZ5 && inquiryAmountFlag">询价数量：{{billDetail.goods_num_sended | numFixed(4)}}</li>
							<li v-show="isZ5 && (billDetail.is_compare_price == 1)">参考含税单价：{{billDetail.reference_price | numFixed(4)}}</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
		<div v-show="scrollShow" class="detail-bill-footer">
			<div class="detail-bill-info" style="float: right">
				<div v-if="billDetailData.bill_state == 30" class="detail-bill-return f-right">
					<a @click="agreen(31)">同意</a>
				</div>
				<div v-if="billDetailData.bill_state == 30 || billDetailData.bill_state == 31" class="detail-bill-red f-right">
					<a @click="refuseB">退回</a>
				</div>
				<div v-if="billDetailData.bill_state == 31" class="detail-bill-return f-right">
					<a @click="billConfirm">确认</a>
				</div>
				<div v-if="billDetailData.bill_state != 30 && billDetailData.bill_state != 39" class="detail-bill-return f-right" style="border-right: solid 1px #fff">
					<a @click="importExcel">Excel</a>
				</div>
			</div>
		</div>
		<loading v-show="loading"></loading>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips v-show="tipsB" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatusB"></tips>
		<tips-t hasTipsFont :btnFont="btnFont" :tipsFont="tipsFont" ref="tipsTShow" v-on:tipStatus = "getStatues"></tips-t>
	</div>
</template>

<script>
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsT from '../components/TipsT'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
export default {
	data () {
		return {
			scrollShow: false,
			tips: false,
			tipsB: false,
			btnNum: 2,
			loading: true,
			tipsauto: false,
			tipsFont: '',
			numScale: 2,
			sec: 1500,
			goodsTotalInfo: {},
			accountInfo: {},
			email: '',
			btnFont: ['确定', '取消'],
			billDetailData: {},
			billDetails: [],
			searchWord: '',
			queryData: this.$route.query,
			show: false,
			billInfoShow: false,
			isPesc: false,
			isZ5: false,
			inquiryAmountFlag: false,
			taxRequired: false
		}
	},
	components: {
		'loading': Loading,
		'tips-auto': TipsAuto,
		'tips': Tips,
		'tips-t': TipsT,
		'navbar': NavBar
	},
	beforeRouteLeave (to, from, next) {
		if (to.path === '/detail-quotation-edit' && this.billDetailData.bill_state === 32) {
			this.$router.go(-1)
		} else {
			next()
		}
	},
	created () {
		this.loading = true
		var filterData = {
			bill_id: this.queryData.bill_id
		}
		// this.goodsTotalInfo = this.store.goodsTotalInfo
		this.getEmail()
		this.$http.post('/cldEdi/business/billWithDetail', filterData).then((response) => {
			const forceUploadPermitFlag = (!response.body.otherdata || response.body.otherdata.forceUploadPermitFlag === null) ? false : response.body.otherdata.forceUploadPermitFlag
			this.isZ5 = response.body.otherdata == null ? false : response.body.otherdata.isZ5
			this.inquiryAmountFlag = response.body.otherdata == null ? false : response.body.otherdata.inquiryAmountFlag
			this.taxRequired = response.body.otherdata == null ? false : response.body.otherdata.taxRequired || false
			this.loading = false
			this.scrollShow = true

			if (!this.isZ5 && forceUploadPermitFlag === true) {
				this.$fxToast.warning('请上传供货商证照信息！')
				this.$router.replace({path: '/main/my'})
			}

			this.billDetailData = response.body.data
			this.numScale = (this.billDetailData.number_scale || this.billDetailData.number_scale === 0) ? this.billDetailData.number_scale : 2
			this.billDetails = response.body.data.details
			this.isPesc = this.billDetailData.isPesc // 是否显示规格的系统参数
		}, (response) => {
			this.loading = false
			this.autoTips('服务请求失败，稍后请重试！')
		})
	},
	methods: {
		getEmail () {
			// 获取邮箱信息
			this.$http.get('/cldEdi/business/getCurrentLoginUser').then((response) => {
				this.accountInfo = response.body.data
				this.email = this.accountInfo.email
			})
		},
		getStatues (msg) {
			switch (msg) {
			case 'bindEmail':
				this.$router.push('/email-bind')
				this.goodsTotalInfo.emailLinksChange = true
				break
			case 'sendEmail':
				this.sendEmail()
				break
			}
		},
		sendEmail () {
			// 对接导出excel并发送邮件接口
			this.loading = true
			var billId = {
				'bill_id': this.queryData.bill_id
			}
			this.$http.post('/cldEdi/business/8001', billId).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.autoTips('邮件发送成功')
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		infoExchange () {
			this.show = !this.show
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			if (this.state === 32 && this.msg[1] === true) {
				this.agreen(32)
				return false
			} else if (this.state === 39 && this.msg[1] === true) {
				this.refuseBack()
				return
			}
		},
		tipStatusB (msg) {
			this.tipsB = false
			this.msg = msg
			if (this.msg[1] === true) {
				this.refuse()
				return false
			}
		},
		autoTips (msg, secp) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, secp || self.sec)
		},
		tipsTShow (str) {
			// 弹出操作提示框
			this.$refs.tipsTShow.open(str)
		},
		importExcel () {
			// 导出Excel
			// 1、判断邮箱是否绑定
			var val = this.email
			if (val === null) {
				// 未绑定邮箱，提示绑定邮箱
				this.tipsFont = '用户尚未绑定邮箱'
				this.btnFont = ['去绑定', '取消']
				this.tipsTShow('bindEmail')
			} else {
				// 已绑定邮箱，提示将excel发送至绑定邮箱
				this.tipsFont = '将单据导出Excel并发送至绑定邮箱'
				this.btnFont = ['确定', '取消']
				this.tipsTShow('sendEmail')
			}
		},
		agreen (state) {
			var updateData = {
				bill_state: state,
				id: this.billDetailData.id
			}
			const hasEmptyTax = this.isZ5 && state === 32 && this.billDetails.some(item => {
				return item.goods_cess === undefined || item.goods_cess === null
			})
			if (hasEmptyTax) {
				this.autoTips('税率不能为空，请修改')
				return false
			}
			const hasZeroTax = this.isZ5 && state === 32 && this.taxRequired && this.billDetails.some(item => {
				return item.goods_cess * 1 === 0
			})
			if (hasZeroTax) {
				this.autoTips('税率不能为0，请修改')
				return false
			}
			this.loading = true
			this.$http.post('/cldEdi/business/bill/updateBillState', updateData).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					if (data && data.data && data.data.billState === 'checked') {
						this.billDetailData.bill_state = state
						this.autoTips('餐企已将采购报价单审核，报价单修改的信息将不会同步到报价单上，自动将单据状态置为已完成；且不会将在供货商EDI中修改的信息同步至供应链的报价单中。', 3000)
					} else {
						this.billDetailData.bill_state = state
						let operMsg = '同意'
						switch (state) {
						case 31:
							operMsg = '报价单已同意'
							break
						case 32:
							operMsg = '报价单已确认'
							break
						}
						this.autoTips(operMsg)
					}
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		refuse () {
			this.tips = true
			this.state = 39
			this.tipsFont = '确认退回报价单？'
		},
		refuseB () {
			this.tipsB = true
			this.tipsFont = '报价单退回后将不可撤销，是否继续？'
		},
		refuseBack () {
			this.loading = true
			var updateData = {
				bill_state: 39,
				id: this.billDetailData.id
			}
			this.$http.post('/cldEdi/business/bill/updateBillState', updateData).then((response) => {
				this.loading = false
				var self = this
				var data = response.body
				if (data.result) {
					this.billDetailData.bill_state = 39
					this.autoTips('报价单已退回')
					setTimeout(function () {
						self.$router.go(-1)
					}, 1500)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		billConfirm () {
			this.state = 32
			this.tips = true
			this.btnNum = 2
			this.tipsFont = '是否确认？'
		},
		openBillInfo () {
			this.billInfoShow = !this.billInfoShow
		},
		formatDate (datetime) {
			if (!datetime || datetime.indexOf('1970-01-01') === 0) {
				return ''
			}

			var d = this.$fxUtils.newDate(datetime)
			return this.$fxUtils.setDateTime(d, '时分')
		}
	},
	filters: {
		// edi小数位数处理
		numFixed (val, scale) {
			// if (scale) {
			// 	return val ? val.toFixed(scale) : ''
			// } else {
			return val
			// }
		}
	},
	computed: {
		sumSubTotalSend () {
			let sumSubTotalSend = 0
			if (this.billDetails) {
				for (let i = 0; i < this.billDetails.length; i++) {
					sumSubTotalSend += this.billDetails[i].sub_total_send
				}
			}
			return sumSubTotalSend
		},
		detailsFilter () {
			if (this.searchWord.trim()) {
				return this.billDetails.filter(detail => detail.goods_name.indexOf(this.searchWord.trim()) >= 0)
			} else {
				return this.billDetails
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// QuotationDetailBill.vue?db0d23ee